import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useLocation, useParams } from 'react-router-dom'
import step0 from '../../../../assets/images/onBoardingFlow/step00.png'
import step1 from '../../../../assets/images/onBoardingFlow/step01.png'
import step2 from '../../../../assets/images/onBoardingFlow/step02.png'
import step4 from '../../../../assets/images/onBoardingFlow/step04.png'
import step3 from '../../../../assets/images/onBoardingFlow/stockStep03.png'
import step5 from '../../../../assets/images/onBoardingFlow/stockStep05.png'
import * as s from './LayoutOnboardingPages.styles'

import { FeathersContext } from '../../../../services/feathers'
import { StepContext } from '../../../../services/stepContext'
/**
 *  3 possibilities: SignUp/Onboarding - Login - SoftApply
 * @param {*} param0
 * @returns
 */
const LayoutOnboardingPages = ({ type, children }) => {
  const stepContext = useContext(StepContext)
  const { t } = useTranslation(['common', 'talent'], { useSuspense: false })
  const location = useLocation()
  const params = useParams()
  const feathers = useContext(FeathersContext)
  const queryParams = new URLSearchParams(location.search)
  const [label, setLabel] = useState('')

  const { data: company } = useQuery({
    enabled: Boolean(params.companyId),
    queryKey: ['company', params.companyId],
    queryFn: async () => {
      const result = await feathers.service('lambda-talent').find({
        query: {
          type: 'getCompany',
          companyId: params.companyId,
        },
      })
      return result
    },
  })

  useEffect(() => {
    switch (type) {
      case 'login':
        setLabel('Candidatez en toute simplicité')
        break
      case 'soft-apply':
        setLabel(queryParams.get('offerName'))
        break
      /* case 'new-apply':
        setLabel(company?.name)
        break */
      default:
        break
    }
  }, [type, queryParams, company])

  return (
    <s.LayoutOnboardingPagesWrapper>
      {!stepContext?.value && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `url(${step0})`,
            position: 'sticky',
            top: '0',
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 1 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `url(${step0})`,
            position: 'sticky',
            top: '0',
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 2 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `url(${step1})`,
            position: 'sticky',
            top: '0',
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 3 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `url(${step2})`,
            position: 'sticky',
            top: '0',
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 4 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${step3})`,
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 5 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `url(${step4})`,
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}
      {stepContext?.value === 6 && (
        <aside
          className="left-illus"
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${step5})`,
          }}
        >
          <h2 style={{ position: 'relative', color: '#fff' }}>{label}</h2>
        </aside>
      )}

      <main className="container-form">{children}</main>
    </s.LayoutOnboardingPagesWrapper>
  )
}

export default LayoutOnboardingPages
